import { useState, useContext, useEffect } from 'react';
import { LayoutContext } from '../contexts';

import { API, extractDataObject } from '../utils/API';

function useFetch(fetchInitialObj) {
  const [data, setData] = useState(null);
  const [fetchObj, doFetch] = useState(fetchInitialObj);
  const { loading, setLoading, error, setError, setSuccessNotification } =
    useContext(LayoutContext);

  useEffect(() => {
    const fetchData = async () => {
      setError(null);
      setSuccessNotification(false);
      try {
        setLoading(true);
        let res = null;
        const config = fetchObj.headers ? { headers: fetchObj.headers } : {};

        switch (fetchObj.method) {
          case 'GET':
            if (fetchObj.params) {
              config.params = fetchObj.params;
            }
            res = await API.get(fetchObj.url, config);
            break;

          case 'POST':
            res = await API.post(fetchObj.url, fetchObj.params, config);
            break;

          case 'DELETE':
            res = await API.delete(fetchObj.url, config);
            break;

          case 'PUT':
            res = await API.put(fetchObj.url, fetchObj.params, config);
            break;

          case 'PATCH':
            res = await API.patch(fetchObj.url, fetchObj.params, config);
            break;

          case 'FILE_POST':
            var formData = new FormData();
            for (const key in fetchObj.params) {
              formData.append(key, fetchObj.params[key]);
            }
            res = await API.post(fetchObj.url, formData, {
              ...config,
              headers: {
                ...config.headers,
                'Content-Type': 'multipart/form-data',
              },
            });
            break;

          default:
            if (fetchObj.params) {
              res = await API.post(fetchObj.url, fetchObj.params, config);
            } else {
              res = await API.get(fetchObj.url, config);
            }
            break;
        }

        setData(res);

        !!fetchObj.onSuccess && fetchObj.onSuccess(extractDataObject(res));
        !!fetchInitialObj &&
          fetchInitialObj.onSuccess &&
          fetchInitialObj.onSuccess(extractDataObject(res));

        fetchObj.showSuccessNotification &&
          setSuccessNotification(fetchObj.successMessage || 'request has been done successfully.');
      } catch (err) {
        console.log(err);
        !!fetchObj.onError && fetchObj.onError(err);
        !!fetchInitialObj && fetchInitialObj.onError && fetchInitialObj.onError(err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    !!fetchObj && !!fetchObj.url && fetchData();

    doFetch(null);
  }, [fetchObj]);

  const defaultResponseValue =
    (fetchObj && fetchObj.defaultValue) || (fetchInitialObj && fetchInitialObj.defaultValue);

  return {
    data: extractDataObject(data, defaultResponseValue),
    error,
    loading,
    doFetch,
  };
}

export default useFetch;
